import { Environment } from "./environment";
import { environment } from "./environment.enum";

const envConf: {
    development: Environment,
    production: Environment,
    test: Environment,
    local: Environment,
} = {
    // some settings for production, development and local are loaded from firestore database
    development: {
    },
    production: {
    },
    test: {
        maptilerKey: 'mock',
        bagKey: 'mock',
    },
    local: {
    }
}

export const setEnvKey = (env: environment, key: string, value: any) => {
    if (value) {
        envConf[env][key] = value;
    }
}

export const getEnvKey = (env: environment, key: string) => {
    const res = envConf[env][key];
    if (!res) {
        console.error(`database key '${key}' does not exist`);
    }
    return res;
}